import { MembershipsCreatorApiClient } from '@fourthwall/services/dist/MembershipsCreatorApiClient'
import { createMutationHook } from '@fourthwall/utils/dist/queries'

export const useCreatePostTagMutation = createMutationHook(
  MembershipsCreatorApiClient.createPostTag,
  {
    mutationKey: ['createPostTag'],
  },
)
